import { RootState } from "../../rootReducer";

export const selectIsDeletingStressCheck = (state: RootState) =>
  state.factorsNEffects.loading;
export const selectDeleteErrorMessage = (state: RootState) =>
  state.factorsNEffects.error;
export const factorsNEffectsDataResponse = (state: RootState) =>
  state.factorsNEffects.factorsNEffectsResponse;
